import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/mall-list',
            name: 'admin-mall-list',
            component: () => import(/* webpackChunkName: "page-admin-buyer-management-mall-list" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "微商城申请审核"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商管理"
                                        },
                                        {
                                                  name: "微商城申请审核"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
